import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import ConnectedPaymentContainer from './PaymentContainer';
import ConnectedWalletGateContainer from '../../components/WalletGateContainer';
import { isLoading } from '../../selectors/account';
import { isFetchingTokenAllowance } from '../../selectors/token';

const PaymentWalletGate = ({ givenProvider, completed, onComplete }) => (
  <ConnectedWalletGateContainer
    loadingSelectors={[isLoading, isFetchingTokenAllowance]}
    givenProvider={givenProvider}
  >
    <ConnectedPaymentContainer completed={completed} onComplete={onComplete} />
  </ConnectedWalletGateContainer>
);

PaymentWalletGate.displayName = 'PaymentWalletGate';

PaymentWalletGate.defaultProps = {
  givenProvider: null,
  completed: false,
  onComplete: noop,
};

PaymentWalletGate.propTypes = {
  givenProvider: PropTypes.shape({}),
  completed: PropTypes.bool,
  onComplete: PropTypes.func,
};

export default PaymentWalletGate;



// WEBPACK FOOTER //
// ./src/containers/createCampaign/PaymentWalletGate.js